import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AuthContextTwo } from "../../contexts/AuthProviderTwo";

const RequestRefound = () => {
  const { userTwo } = useContext(AuthContextTwo);

  const [PaidData, setPaidData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const url = `https://tutor-tree-server-1.vercel.app/verifyMainData`;
      console.log("url", url);
      const res = await fetch(url);
      const data = await res.json();
      setPaidData(data);
    };

    fetchData();
  }, []);

  const verifyData = PaidData.filter(
    (invoice) => invoice.teacherEmail === userTwo?.email
  );

  console.log("verifyData", verifyData);
  console.log("invoice", PaidData);
  return (
    <div>
      <div>
        {Array.isArray(PaidData) && PaidData.length > 0 ? (
          PaidData.map((invoice) => (
            <div className="flex mt-5 lg:flex-row sm:flex-col  lg:justify-between lg:items-center px-10 py-5 w-full  border rounded-xl first-letter:hover:border-2 focus border-orange-500">
              <div>
                <h1 className="textBold">
                  Invoice:{" "}
                  <span className="textOrange">
                    5412 {invoice.teacherEmail}
                  </span>
                </h1>
                <h1 className="textBold mt-4">
                  Amount:{" "}
                  <span className="textOrange">{invoice.inputData} tk</span>
                </h1>
                <h1 className="textBold mt-4">
                  Status:{" "}
                  <span className="textOrange">
                    {invoice.PendingData === "SentInvoice"
                      ? "Payment Due"
                      : "Status"}
                  </span>
                </h1>
                <h1 className="textBold mt-4">
                  Last Date:{" "}
                  <span className="textOrange">{invoice.EndDate}</span>
                </h1>
              </div>
              <div className="flex flex-col sm:mt-5 lg:mt-32 sm:justify-end">
                <Link
                  to={`/dashboardTwo/RefoundDetails/${invoice._id}`}
                >
                  <button className="detailsBtn">Details</button>
                </Link>
              </div>
            </div>
          ))
        ) : (
          <p>No data available</p>
        )}
      </div>
    </div>
  );
};

export default RequestRefound;
